// extracted by mini-css-extract-plugin
export default {"copyWrapper":"qdTr9FkFJ2azj7BjQGtv","copyTip":"q6OaTjv7qJMvDntHL3HX","show-and-hide":"B0DUPARDT7pjXWEJcIOB"};